import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAttendanceStore } from ".././AttendanceSummaryReport/store/useAttendanceStore";
import Loader from "../../../../Common/Loader/loader";
import MUITable from "../../../../Common/MUITable";
import { ExportZoneLevelDrillDown } from "./ExportsAttendanceSummary/ExportZoneLevelDrillDown";
const ZoneLevelDrillDown = () => {
  const navigate = useNavigate();
  const {
    isFetchingZoneLevelDetails,
    fetchZoneLevelDetails,
    zoneLevelDetails,
  } = useAttendanceStore();
  const filters = JSON.parse(
    localStorage.getItem("attendance-summary-filters")
  );
  const fromDateTime = filters?.FromDateTime;
  const toDateTime = filters?.ToDateTime;
  const zoneId = filters?.ZoneId;
  useEffect(() => {
    if (zoneId && fromDateTime && toDateTime) {
      fetchZoneLevelDetails({ 
        zoneId: String(zoneId), 
        fromDateTime: String(fromDateTime), 
        toDateTime: String(toDateTime) 
      }); // Pass correct payload
    }
  }, [zoneId, fromDateTime, toDateTime, fetchZoneLevelDetails]);

  const zoneLevelDetailsColumns = [
    {
      label: "Operation Name",
      field: "operationName",
      render: (row) => row.operationName,
    },
    {
      label: "Designation",
      field: "designationName",
      render: (row) => row.designationName,
    },
    {
      label: "Planned Attendance",
      field: "plannedAttendance",
      render: (row) => row.plannedAttendance,
    },
    {
      label: "Biometric Attendance",
      field: "biometricAttendance",
      render: (row) => row.biometricAttendance,
    },
    {
      label: "Forced Attendance",
      field: "forcedAttendance",
      render: (row) => row.forcedAttendance,
    },
    {
      label: "BA + FA",
      field: "bA_FA",
      render: (row) => row.bA_FA,
    },
    {
      label: "Shortfall",
      field: "shortfall",
      render: (row) => row.shortfall,
    },
    {
      label: "Attendance %",
      field: "attendancePercentage",
      render: (row) => row.attendancePercentage,
    },
  ];

  return (
    <>
      <div className="content">
        <div className="page-content">
          <h4 className="text-start mb-3">Zone Level Drill Down</h4>
          <div className="page-header">
            <div className="card mt-3">
              <div className="">
                {isFetchingZoneLevelDetails && <Loader />}
                <div className="d-flex justify-content-end mt-3 mb-3 mr-3">
                  <ExportZoneLevelDrillDown />
                  <button
                    className="btn btn-secondary me-2 ml-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>

                <MUITable
                  needSRNumber
                  columns={zoneLevelDetailsColumns}
                  rows={zoneLevelDetails || []} // Ensure it's an array
                  tableHeight={500}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZoneLevelDrillDown;
